import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CampaignIcon from '@mui/icons-material/Campaign';
import { getAnnouncementBanner } from '../../services/api';

interface BannerData {
  enabled: boolean;
  show_for_guests: boolean;
  text: string;
  url: string;
  link_text: string;
}

interface AnnouncementBannerProps {
  isLoggedIn: boolean;
}

const AnnouncementBanner: React.FC<AnnouncementBannerProps> = ({ isLoggedIn }) => {
  const [banner, setBanner] = useState<BannerData | null>(null);
  const theme = useTheme();

  useEffect(() => {
    const fetchBanner = async () => {
      const data = await getAnnouncementBanner();
      if (data) setBanner(data);
    };
    fetchBanner();
  }, []);

  if (!banner) return null;
  if (!isLoggedIn && !banner.show_for_guests) return null;

  return (
    <Box
      component="a"
      href={banner.url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        mt: 4,
        px: 2,
        py: 1,
        borderRadius: '20px',
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(8px)',
        color: 'rgba(255, 255, 255, 0.7)',
        fontSize: { xs: '0.7rem', sm: '0.8rem' },
        lineHeight: 1.2,
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
        }
      }}
    >
      <CampaignIcon sx={{ fontSize: { xs: 16, sm: 18 } }} />
      <span>{banner.text}</span>
    </Box>
  );
};

export default AnnouncementBanner;
